module.exports = __webpack_public_path__ + "static/media/55473413_2519309358144240_8902220053479424000_o.474ad9fd.jpg";